export class Breakpoints {
    //lower the breakpoints by 1, so that the breakpoints act at the right places
    static BREAKPOINTS = {
        XS: 0,
        SM: 767,
        MD: 991,
        MDLG: 1023,
        LG: 1439,
        XL: 1919,
        XXL: 1999
    };

    static breakpointNames = ['xs', 'sm', 'md', 'mdlg', 'lg', 'xl', 'xxl'];
    static _breakpointChangeCallbacks = [];

    static onBreakpointChange(callback) {
        if (typeof callback !== 'function') throw new TypeError('Callback must be a function.');

        const breakpointChangeCallback = {
            from: null,
            to: null,
            callback: callback
        };

        Breakpoints._breakpointChangeCallbacks.push(breakpointChangeCallback);
    }

    static onBreakpointChangeFromSmallerTo(to, callback) {
        if (typeof callback !== 'function') throw new TypeError('Callback must be a function.');
        if (typeof !Breakpoints.breakpointNames.includes(from)) throw new TypeError('"from" breakpoint not known');

        const breakpointChangeCallback = {
            from: 'smaller',
            to: to,
            callback: callback
        };

        Breakpoints._breakpointChangeCallbacks.add(breakpointChangeCallback);
    }

    static onBreakpointChangeFromBiggerTo(to, callback) {
        if (typeof callback !== 'function') throw new TypeError('Callback must be a function.');
        if (typeof !Breakpoints.breakpointNames.includes(from)) throw new TypeError('"from" breakpoint not known');

        const breakpointChangeCallback = {
            from: 'bigger',
            to: to,
            callback: callback
        };

        Breakpoints._breakpointChangeCallbacks.add(breakpointChangeCallback);
    }

    static onBreakpointChangeFromTo(from, to, callback) {
        if (typeof callback !== 'function') throw new TypeError('Callback must be a function.');
        if (typeof !Breakpoints.breakpointNames.includes(from)) throw new TypeError('"from" breakpoint not known');
        if (typeof !Breakpoints.breakpointNames.includes(to)) throw new TypeError('"to" breakpoint not known');

        const breakpointChangeCallback = {
            from: from,
            to: to,
            callback: callback
        };

        Breakpoints._breakpointChangeCallbacks.add(breakpointChangeCallback);
    }

    static onBreakpointChangeFrom(from, callback) {
        if (typeof callback !== 'function') throw new TypeError('Callback must be a function.');
        if (typeof !Breakpoints.breakpointNames.includes(from)) throw new TypeError('"from" breakpoint not known');

        const breakpointChangeCallback = {
            from: from,
            to: null,
            callback: callback
        };

        Breakpoints._breakpointChangeCallbacks.push(breakpointChangeCallback);
    }

    static onBreakpointChangeTo(to, callback) {
        if (typeof callback !== 'function') throw new TypeError('Callback must be a function.');
        if (typeof !Breakpoints.breakpointNames.includes(to)) throw new TypeError('"to" breakpoint not known');

        const breakpointChangeCallback = {
            from: null,
            to: to,
            callback: callback
        };

        Breakpoints._breakpointChangeCallbacks.push(breakpointChangeCallback);
    }

    static getBreakpoint() {
        let breakpoint = 'xs';
        const width = $(window).width() + (window.innerWidth-$(document).width());
      
        for (const [key, value] of Object.entries(Breakpoints.BREAKPOINTS)) {
            if (value < width) breakpoint = key;
        }
    
        return breakpoint.toLowerCase();
    }
    
    static isBreakpoint(breakpointName) {
        return breakpointName.toLowerCase() === Breakpoints.getBreakpoint();
    }

    static isBreakpointOrLarger(breakpointName) {
        const breakpointIndex = this.breakpointNames.indexOf(breakpointName);
        const currentBreakpointIndex = this.breakpointNames.indexOf(Breakpoints.getBreakpoint());

        return breakpointIndex <= currentBreakpointIndex;
    }

    static isBreakpointOrSmaller(breakpointName) {
        const breakpointIndex = this.breakpointNames.indexOf(breakpointName);
        const currentBreakpointIndex = this.breakpointNames.indexOf(Breakpoints.getBreakpoint());

        return breakpointIndex >= currentBreakpointIndex;
    }

    static _initBreakpointChangeListener() {
        let lastBreakpoint = Breakpoints.getBreakpoint();
    
        $(window).on('resize', () => {
            const currentBreakpoint = Breakpoints.getBreakpoint();
    
            if (currentBreakpoint !== lastBreakpoint) {
                Breakpoints._breakpointChangeCallbacks.forEach((callbackSetting) => {
                    if (Breakpoints._callbackShouldFire(lastBreakpoint, currentBreakpoint, callbackSetting)) {
                        callbackSetting.callback();
                    }
                });
            };
    
            lastBreakpoint = currentBreakpoint;
        });
    }

    static _callbackShouldFire(lastBreakpoint, currentBreakpoint, callbackSetting) {
        return  callbackSetting.from === null && callbackSetting.to === null ||
                callbackSetting.from === lastBreakpoint && callbackSetting.to === null ||
                callbackSetting.from === null && callbackSetting.to === currentBreakpoint ||
                callbackSetting.from === lastBreakpoint && callbackSetting.to === currentBreakpoint ||
                callbackSetting.from === 'smaller' && callbackSetting.to === currentBreakpoint 
                    && this.breakpointNames.indexOf(lastBreakpoint) < Breakpoints.breakpointNames.indexOf(currentBreakpoint) ||
                callbackSetting.from === 'bigger' && callbackSetting.to === currentBreakpoint
                    && this.breakpointNames.indexOf(lastBreakpoint) > Breakpoints.breakpointNames.indexOf(currentBreakpoint);
    }
}

(() => {
    Breakpoints._initBreakpointChangeListener();
})();